/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFollowers.defs.js'
export { main as default } from './getFollowers.defs.js'
